/**
 * Checks wether the given `value` implements the interface [[StepOffset]].
 *
 * @param value The value to be checked
 * @returns {boolean} True if the given value implements [[StepOffset]] and false otherwise
 */
export function isStepOffset(value) {
    return value.hasOwnProperty('stepOffset');
}
//# sourceMappingURL=step-offset.interface.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng2-archwizard/dist/util/step-offset.interface.js
// module id = ../../../../ng2-archwizard/dist/util/step-offset.interface.js
// module chunks = 3